// import FloorPlan_1 from '../assets/TWC - C2.1.webp';
// import FloorPlan_2 from '../assets/TWC - C2.2.webp';
// import FloorPlan_3 from '../assets/TWC - C2.3.webp';
// import Building_Floor from '../assets/Building-Layout.webp';
import VIZ_1 from '../assets/sample.webp';
// import VIC_2 from '../assets/vic-2.webp';
// import Mini_1 from '../assets/Mini-1.png';
// import Mini_2 from '../assets/Mini-2.png';
// import Mini_3 from '../assets/Mini-3.png';

export const FLOOR_PLANS_LAYOUT = {
  'viz-1': {
    image: VIZ_1,
    totalApartments: '1.686',
    totalElevators: 12,
    // 'viz-1.1': {
    //   '6-22': FloorPlan_1,
    //   mini: Mini_1,
    //   totalApartments: 504,
    //   totalElevators: 5,
    // },
    // 'vic-1.2': {
    //   '6-22': FloorPlan_2,
    //   '23-25': FloorPlan_2,
    //   mini: Mini_2,
    //   totalApartments: 462,
    //   totalElevators: 6,
    // },
    // 'vic-1.3': {
    //   '6-22': FloorPlan_3,
    //   '26-28': FloorPlan_3,
    //   mini: Mini_3,
    //   totalApartments: 480,
    //   totalElevators: 6,
    // },
  },
  // 'vic-2': {
  //   image: VIC_2,
  //   totalApartments: '1.446',
  //   totalElevators: 17,
  // 'vic-2.1': {
  //   '6-22': FloorPlan_1,
  //   mini: Mini_1,
  //   totalApartments: 504,
  //   totalElevators: 5,
  // },
  // 'vic-2.2': {
  //   '6-22': FloorPlan_2,
  //   '23-25': FloorPlan_2,
  //   mini: Mini_2,
  //   totalApartments: 462,
  //   totalElevators: 6,
  // },
  // 'vic-2.3': {
  //   '6-22': FloorPlan_3,
  //   '26-28': FloorPlan_3,
  //   mini: Mini_3,
  //   totalApartments: 480,
  //   totalElevators: 6,
  // },
  // },
};
